var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEyeSmall = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M8 12.667c3.057 0 5.83-1.637 7.875-4.295a.61.61 0 0 0 0-.74C13.829 4.97 11.057 3.334 8 3.334S2.17 4.97.125 7.629a.61.61 0 0 0 0 .74C2.171 11.03 4.943 12.667 8 12.667m-.22-7.953c2.03-.125 3.706 1.512 3.578 3.5-.105 1.64-1.463 2.97-3.139 3.073-2.029.124-3.705-1.512-3.577-3.501C4.75 6.149 6.108 4.82 7.78 4.714m.102 1.518c1.093-.067 1.997.814 1.925 1.884-.056.884-.79 1.598-1.692 1.656-1.094.067-1.997-.814-1.925-1.884.059-.887.792-1.601 1.692-1.656"
})));
export default SvgEyeSmall;